export default __webpack_public_path__ + "static/media/i145vp.0749c02b.webp";